import { User } from '../../user'

export class DLDocument {
  id: string
  
  filename: string
  filesize: number
  filetype: string

  date: string
  comment?: string

  rootCertificateName: String
  rootCertificatePem: String
  
  createdAt: number
  createdBy: User

  constructor(data: any = {}) {
    Object.assign(this, data);

    if(this.createdBy) {
      this.createdBy = new User(this.createdBy);
    }
  }
}
